import { Box, Button } from '@chakra-ui/react';
import { parseAsString, useQueryState } from 'nuqs';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface MentionThumbnailPreviewSurfaceProps {
  mentionId: string;
  openOnClick?: boolean;
  children: ReactNode;
}

export function MentionThumbnailPreviewSurface({
  mentionId,
  openOnClick = true,
  children,
}: MentionThumbnailPreviewSurfaceProps) {
  const { t } = useTranslation();
  const [, setPreviewMentionId] = useQueryState('previewMention', parseAsString);

  const surfaceProps = {
    position: 'relative' as const,
    width: '100%',
    height: '100%',
    bg: 'black',
    rounded: 'none',
    overflow: 'hidden',
  };

  if (!openOnClick) {
    return <Box {...surfaceProps}>{children}</Box>;
  }

  return (
    <Button
      type="button"
      aria-label={t('mentions.preview.openLabel')}
      variant="plain"
      minW={0}
      p={0}
      border={0}
      textAlign="initial"
      cursor="pointer"
      onClick={() => setPreviewMentionId(mentionId)}
      {...surfaceProps}
    >
      {children}
    </Button>
  );
}
